
import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseClass } from '../../utility/baseClass';
import { UsersService } from '../../main-layout/users/users.service';
import { LocationService } from '../../main-layout/location/location.service';
import { Entityservice } from '../../main-layout/entity/entityservice';
import { DepartmentService } from '../../main-layout/department/department.service';
import { Verticalservice } from '../../main-layout/vertical/verticalservice.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { first } from 'rxjs';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-usermodal',
  templateUrl: './usermodal.component.html',
  styleUrls: ['./usermodal.component.css']
})
export class UsermodalComponent extends BaseClass implements OnInit {

  entityList = [];
  verticalList = []
  verticalList1 = []
  departmentList = []
  locationList = []
  productList = []
  roleList = []
  rightsList: Array<any> = []
  managerList = []
  cityList = [];
  filterentitydata: Array<any> = [];
  saveTitle = 'Add'
  mappedmoduleForm: FormGroup;
  userDetails: any = {};
  userxproductlist = [];
  productxrolelist = [];
  onlyView: any = false;
  isEdit: boolean = false;
  selectedDepartment = [];
  selectedCompany = [];
  selectedLocation = [];
  selectedVertical = [];
  selectedProduct = [];
  prodid = [];
  userForm: FormGroup;
  rolelistdynamic: { roleid: any, rolename: string }[][] = [];
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  dailyFlag = [
    {
      'labelname': 'Yes',
      'value': 'Y'
    },
    {
      'labelname': 'No',
      'value': 'N'
    }
  ]
   threemonthLocklist = [
    {
      'labelname': 'Open',
      'value': 'N'
    }
  ]
  lockStatus = [
    {
      'labelname': 'Locked',
      'value': 'L'
    },
    {
      'labelname': 'Open',
      'value': 'N'
    }
  ]
  sendmaillist = [
    {
      'labelname': 'YES',
      'value': 'Y'
    },
    {
      'labelname': 'NO',
      'value': 'N'
    }
  ]
  userrolelist = [
    {
      'labelname': 'Select',
      'value': ''
    },
    {
      'labelname': 'Administrator',
      'value': '1'
    },
    {
      'labelname': 'Senior Management',
      'value': '2'
    },
    {
      'labelname': 'Owner/Manager',
      'value': '3'
    }
  ];
  YesNolist = [
    {
      'labelname': 'YES',
      'value': 'Y'
    },
    {
      'labelname': 'No',
      'value': 'N'
    }
  ]
  CSRFToken = ''
  userid: any = 0
  existingdetails: any = {}
  options: any[] = []; // Define options property as an array
  filter: boolean = true;
  selectedValue: any;
  loginuserdetails: any;
  orgType: String = "";
  licenseType: string = '';
  modalType: String;
  isNormalAdmin: String;
  isBusinessUser: String;
  isBusinessUserRequired: String;
  currentNumberOfBusinessUsers: number;
  numberOfBusinessUsers: number;
  payload = {};
  clientGroupList = [];
  authType: String;
  numberOfUsers:number
  currentNumberOfusers:number
  userRights:any
orgid:any;
filterInput:any
configparams:any
  extraDetails: { modalType?: string; orgType?: string; isNormalAdmin?: string; isBusinessUser?: string; isBusinessUserRequired?: string; currentNumberOfBusinessUsers?: number; numberOfBusinessUsers?: number;  authType?: string;[key: string]: any ;currentNumberOfUsers?:number; numberOfUsers?:number} = {};
  constructor(
    private usersService: UsersService,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector,
    public ref: DynamicDialogRef, private userService: UsersService, private depservice: DepartmentService,
    private entityservice: Entityservice, private verticalservice: Verticalservice,
    private locservice: LocationService, private utilityservice: Utilityservice,
    public config: DynamicDialogConfig,
    private el:ElementRef,
    private spinner:NgxSpinnerService

  ) {
    super(injector);
    this.utilityservice.fetchAndStoreConfigParams()
       this.utilityservice.configParams$.subscribe(res => {
       this.configparams=res;      

      })
    this.loginuserdetails = this.utilityservice.getLoggeduser();
     this.userRights = this.utilityservice.getUserRights();

    //alert(JSON.stringify(this.loginuserdetails));
    this.orgType = this.loginuserdetails.orgtype;

    const dataFromParent = this.config.data;
    this.extraDetails = dataFromParent?.extraDetails || {};
    this.filterInput=dataFromParent.filters||{}
    this.modalType = this.extraDetails.modalType;
    this.isNormalAdmin = this.extraDetails.isNormalAdmin;
    this.isBusinessUserRequired = this.extraDetails.isBusinessUser;
    this.isBusinessUser = 'N';//as disscuseed with santosh on 28 april
    this.currentNumberOfBusinessUsers = this.extraDetails.currentNumberOfBusinessUsers;
    this.numberOfBusinessUsers = this.extraDetails.numberOfBusinessUsers;
    this.authType = this.extraDetails.authType;
    this.currentNumberOfusers=this.extraDetails.currentNumberOfUsers
    this.numberOfUsers=this.extraDetails.numberOfUsers
   
 

       
    this.payload =
    {
      "modalType": this.modalType,
      "orgType": this.orgType,
      "isNormalAdmin": this.isNormalAdmin,
      "isBusinessUser": 'N'}
    this.gettoken();
    if (dataFromParent?.title == 'Modify User') {
      this.payload["modalType"]='modify'
      this.payload[ "orgId"]=this.orgid
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.formInitiliaze();
        this.mappedmoduleForm = this.fb.group({
        Rows: this.fb.array([this.initRows()])
      });
      this.existingdetails = dataFromParent.datas.list;
      this.getuserxproductlist(dataFromParent.datas.userid);
      this.userid = dataFromParent.datas.userid;
      this.payload['isBusinessUser']=this.existingdetails[0].isbussinessuser;  //as discussed with santosh sir on 28-april-2026
      // this.userForm.controls['userrole'].removeValidators([Validators.required]);
      // this.userForm.updateValueAndValidity();
      if (this.configparams.requirevertlabel == 'Y') {
        this.dynamicformValidation(this.userForm, 'verticalid', { required: true })
        // this.userForm.get('verticalid')?.clearValidators();
        // this.userForm.get('verticalid')?.updateValueAndValidity();
      }
       if (this.loginuserdetails.orgid == 1) {
        this.dynamicformValidation(this.userForm, 'verticalid1', { required: true })
      }     
        if(this.authType=='AD'){
          this.dynamicformValidation(this.userForm, 'loginid', { required: true});
          }
      this.userForm.get('userrole')?.clearValidators();
      this.userForm.get('userrole')?.updateValueAndValidity();
      this.userForm.get('productid')?.clearValidators();
      this.userForm.get('productid')?.updateValueAndValidity();
      if (this.orgType == 'P') {
        this.dynamicformValidation(this.userForm, 'groupid', { required: true }) 
      }
    }

    if (dataFromParent.title == 'Mapped Module') {
      this.onlyView = true;
      this.isEdit = false;
      this.mappedmoduleForm = this.fb.group({
        Rows: this.fb.array([this.initRows()])
      });
      this.getProductList(this.payload);
      this.existingdetails = dataFromParent.datas.list;
      this.getuserxproductlistformap(dataFromParent.datas.userid);
    }

  }


  ngOnInit() {
    this.mappedmoduleForm = this.fb.group({
      Rows: this.fb.array([this.initRows()])
    });
    if (!this.isEdit) {
      this.formInitiliaze();
      this.licenseType = 'normalLicensed';
       if (this.loginuserdetails.orgid == 1) {
        this.dynamicformValidation(this.userForm, 'verticalid1', { required: true })
      }
      if (this.orgType == 'P') {        
        this.dynamicformValidation(this.userForm, 'groupid', { required: true }) 
      }
        if(this.authType=='AD'){
          this.dynamicformValidation(this.userForm, 'loginid', { required: true});
          }
  
      this.userForm.get('userType')?.setValue('N');
      this.onLicenseChange('N');
      if (this.configparams.requirevertlabel == 'Y') {
        this.dynamicformValidation(this.userForm, 'verticalid', { required: true })
      }
    }

    if (this.configparams.requirevertlabel == 'Y') { this.getVerticalList(); }
    this.getVerticalList1();
    this.getEntityList();
    this.getDepartmentList();
    this.getLocationList();
    this.getManagerList();
    this.getProductList(this.payload);
    this.getData();
    if (this.loginuserdetails.orgtype == 'P') { this.getClientGroupList(); }
  }
  getData() {
    if (this.isEdit) {
      this.patchValueForms(this.existingdetails[0])
    }
  }
  addnewrow() {
    this.formArr.push(this.initRows())
  }
  get formArr() {
    return this.mappedmoduleForm.get("Rows") as FormArray;
  }
   getformarraycontroles(index: number): FormArray {
    return this.mappedmoduleForm.get('Rows') as FormArray;
  }
  deleteRow(index: number) {
    if(this.loginuserdetails.isorgadmin === 'Y'){
        this.formArr.removeAt(index);
    Swal.fire(" Product is deleted successfully!","","success")
    if (index > -1 && this.userDetails.length > 1) { // only splice array when item is found
      this.userDetails.splice(index, 1); // 2nd parameter means remove one item only
    }
    }
    else{
    Swal.fire ("Please contact organization admin to delete assigned Product.", "", "error");
  
  }
  }

  deleteRownew(index: number) {

  const control = this.formArr.at(index) as FormGroup;

  if (this.loginuserdetails.isorgadmin === 'Y' || control.value.candelete) {
    this.formArr.removeAt(index);

    Swal.fire("Product is deleted successfully!", "", "success");

    if (index > -1 && this.userDetails.length > 1) {
      this.userDetails.splice(index, 1);
    }
  } else {
    Swal.fire("Please contact organization admin to delete assigned Product.", "", "error");
  }
}
  onSelectProduct(event, i) {
    console.log(event);
    if(event!=='' && event!==null && event!==undefined){
    this.getproductxrolelist(event, i)
  }else{
    //   this.formArr.controls.push(
    //   this.fb.group({
    //     productid: '',
    //     role: ,
    //     create: item.createright == 'Y' ? true : false,
    //     download: item.downloadright == 'Y' ? true : false,
    //     topmenu: item.istopmenu == 'Y' ? true : false
    //   })
    // )
  }
  }
  getProductList(payload) { 
    
   if(this.loginuserdetails.orgid===0){
        payload["orgid"]=this.filterInput.torganisation
  }else{
      payload["orgid"]=this.loginuserdetails.orgid
  }    
    this.userService.getproductforlist(payload).subscribe(res => {
      this.productList = res;


      if (!this.isEdit && this.userForm) {        
        const activeProducts = this.productList.filter(p => p.activeflag === 'Y');
        this.userForm.patchValue({
          productid: activeProducts
        });
      }
      if(this.isEdit){
           this.productList.unshift({ productid: '', productname: 'Select' });
          }
                    

    })
  }
 manualpasswordreset: string = "";
autoresetpaswrd = false;
isresetmodal = false;
Newpassword = "";
passwordmessage = "";
viewpassword=false
generatedpswd=""
resetpassword() {
  let orgid=this.loginuserdetails.orgid;
  let type=""
    if(this.loginuserdetails.orgid===0){
        orgid=this.filterInput.torganisation
  }
  if (this.manualpasswordreset === 'manualpasswordreset') {
  type="manual"
    if(this.Newpassword!==''){
  
const passwordPattern = /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?!^\d+$).{8,}$/;

if(!passwordPattern.test(this.Newpassword)){
  this.passwordmessage = "Password must be 8 characters, start with capital letter and contain one special character";
  return;
}else{
  const payload={
    userid:this.userid,
    orgid:orgid,
    type:type,
    password:this.Newpassword
  }
  this.userService.manuallyresetpassword(payload).subscribe(res=>{
    console.log(res);
    this.isresetmodal=false;
    this.viewpassword=true;
    this.generatedpswd=res.password
    
  })
}

}
else{
  Swal.fire('Enter New Password','','warning')
}

this.passwordmessage = "";
  }else{
  const payload={
    userid:this.userid,
    orgid:orgid,
    type:type,
  }
  this.userService.manuallyresetpassword(payload).subscribe(res=>{
    console.log(res);
      this.isresetmodal=false;
    this.viewpassword=true;
    this.generatedpswd=res.password
    
  })
  }
}
clearPasswordError(){
  this.passwordmessage =""
}

onresetChange(value: string) {
  console.log(value);
  this.manualpasswordreset = value;
}
 notZeroValidator(control: AbstractControl) {

  const value = control.value;

  if (value === null || value === '' || value === 0 || value === '0') {
    return { required: true };
  }

  return null;
}
adminproductslist=[]
getAdminRoleswithLoggeduser(userid){
this.userService.getloggedinuseradminroleswithproducts(userid).subscribe(res=>{
  this.adminproductslist=res;
  
})
}
  getuserxproductlist(userid) {
    const payload = {
      "userid": userid
    }
    this.getAdminRoleswithLoggeduser(this.loginuserdetails.userid);
    
    this.usersService.getuserxproductdetails(payload).subscribe((data) => {
      this.userxproductlist = data;
      //this.userxproductlist=data;
      this.formArr.clear();
      //this.userxproductlist=data;
this.userxproductlist.forEach((item, i) => {

  const productId = Number(item.productid);
  const roleId = Number(item.roleid);

  const isAdminProduct = this.adminproductslist.some(
    p => Number(p.productid) === productId
  );
     // CASE 1: Super Admin can change any role

  if (this.loginuserdetails.isorgadmin === 'Y') {
        console.log("org admin 429");


    this.rolelistdynamic[i] = [...item.productroles];

  }
  // CASE 2: login user is not admin
  else if (Number(this.userRights.roleid) !== 1) {
    console.log("not admin 435");
    

    this.rolelistdynamic[i] = item.productroles.filter(
      r => Number(r.roleid) === roleId
    );

  }

  // CASE 3: editing own user
  else if (this.loginuserdetails.userid === userid) {
        console.log("same user");


    this.rolelistdynamic[i] = item.productroles.filter(
      r => Number(r.roleid) === roleId
    );

  }


  // CASE 4: product is admin product AND target role is not admin
  else if (isAdminProduct && roleId !== 1) {
console.log("admin products and role ! 1");

    this.rolelistdynamic[i] = [...item.productroles];

  }
 

  // CASE 5: admin cannot change admin role
  else {
    console.log("in else admin can not change the admin role");
    

    this.rolelistdynamic[i] = item.productroles.filter(
      r => Number(r.roleid) === roleId
    );

  }

  // add Select option
  this.rolelistdynamic[i].unshift({ roleid: '', rolename: 'Select' });

  // push form row
  this.formArr.push(
    this.fb.group({
      productid: [productId || '', Validators.required],
      role: [roleId || '', Validators.required],
      create: item.createright === 'Y' ? true : false,
      download: item.downloadright === 'Y' ? true : false,
      topmenu: item.istopmenu === 'Y'? true : false,
      candelete:false
    })
  );

});
          this.mappedmoduleForm.markAllAsTouched();
this.mappedmoduleForm.updateValueAndValidity({ onlySelf: false });
this.formArr.updateValueAndValidity();


    })
  }
  getuserxproductlistformap(userid) {
    const payload = {
      "userid": userid
    }
    this.usersService.getuserxproductdetails(payload).subscribe((data) => {
      this.userxproductlist = data;
      this.formArr.clear();
      //this.userxproductlist=data;

      this.userxproductlist.forEach((item, i) => {

        this.formArr.controls.push(
          this.fb.group({
            productid: item.productname,
            role: item.rolename,
            create: { value: item.createright == 'Y' ? true : false, disabled: true },
            download: { value: item.downloadright == 'Y' ? true : false, disabled: true },
            topmenu: { value: item.istopmenu == 'Y' ? true : false, disabled: true }
          })
        )
      })
    })
  }
  getproductxrolelist(productid, index) {

    const payload = { productid: productid };

    this.usersService.getproductxroledetails(payload).subscribe((data) => {
      const roleList = [];
      data.forEach((e) => {
        const roleIdArray = e.roleid.split(',');
        const roleNameArray = e.rolename.split(',');

        for (let i = 0; i < roleIdArray.length; i++) {
          roleList.push({
            roleid: parseInt(roleIdArray[i], 10), // Convert roleId to integer
            rolename: roleNameArray[i]
          });
        }
      });

      // Update rolelistdynamic in a single assignment to minimize change detection cycles
      this.rolelistdynamic[index] = roleList;
                            this.rolelistdynamic[index].unshift({ roleid: '', rolename: 'Select' });      

    }, error => {
      console.error('Error fetching role details:', error);
    });
  }
  getproductxrolelistpatchvalue(item, index) {
    console.log("item ",item);
    const payload = { "productid": item.productid };
      //alert('PUSHING PRODUCT:'+ item.productname );
    //  this.formArr.clear();
    this.usersService.getproductxroledetails(payload).subscribe((data) => {
      const roleList = [];
      data.forEach(e => {
        const roleIdArray = e.roleid.split(',');
        const roleNameArray = e.rolename.split(',');
        for (let i = 0; i < roleIdArray.length; i++) {
          roleList.push({
            roleid: parseInt(roleIdArray[i], 10),
            rolename: roleNameArray[i]
          });
        }
      });
      this.rolelistdynamic[index] = roleList;
    })
    this.formArr.controls.push(
      this.fb.group({
        productid: item.productid,
        role: item.roleid,
        create: item.createright == 'Y' ? true : false,
        download: item.downloadright == 'Y' ? true : false,
        topmenu: item.istopmenu == 'Y' ? true : false
      })
    )
  }
  getEntityList() {
    this.userService.getEntityList(this.filterInput).subscribe(res => {
      this.entityList = res;
      if (this.isEdit && this.entityList.length > 0) {
        const companyidlist = this.utilityservice.stringFromNumArray(this.existingdetails[0].companyid);
        let id = companyidlist.map(id => this.entityList.find(item => item.companyid === id)).filter(item => item !== undefined);   // remove undefined

if (id.length > 0) {
  this.userForm.patchValue({ companyid: id });
} else {
  this.userForm.patchValue({ companyid: '' });
}
      }
     
    })
  }
  getManagerList() {
    this.userService.getusersforlist(this.filterInput).subscribe(res => {
      this.managerList = res;
            this.managerList.unshift({ userid: '-1', fullname: 'Select' });

    })
  }
  getVerticalList() {
    this.verticalList = [];
    this.usersService.getvertical(this.filterInput).subscribe(res => {
      this.verticalList = res;

      if (this.isEdit && this.verticalList.length > 0) {
        const list = this.utilityservice.stringFromNumArray(this.existingdetails[0].verticalid);
        console.log(list);
        let id = ''
        list.map(e => {
          if (e !== 0) {
            id = list.map(id => this.verticalList.find(item => item.verticalid === id));
          }
        })
        console.log(id);
        this.userForm.patchValue({ 'verticalid': id });
      }
    })
  }
  getVerticalList1() {
    this.verticalList1 = [];
    this.usersService.getvertical(this.filterInput).subscribe(res => {
      this.verticalList1 = res;

      if (this.isEdit && this.verticalList1.length > 0) {
        // const list = this.utilityservice.stringFromNumArray(this.existingdetails[0].verticalid1);
        // console.log(list);
        // let id = ''
        // list.map(e => {
        //   if (e !== 0) {
        //     id = list.map(id => this.verticalList1.find(item => item.verticalid === id));
        //   }
        // })
        // console.log(id);
        this.userForm.patchValue({ 'verticalid1': Number(this.existingdetails[0].verticalid1 )});
      }
    })
  }
  getDepartmentList() {
    this.userService.getdepartmentforlist(this.filterInput).subscribe(res => {
      this.departmentList = res;
      if (this.isEdit && this.departmentList.length > 0) {
        const deplist = this.utilityservice.stringFromNumArray(this.existingdetails[0].departmentid);
        const depid = deplist.map(id => this.departmentList.find(item => item.departmentid === id));
        this.userForm.patchValue({ 'departmentid': depid });
      }
    })
  }
  getLocationList() {
    this.userService.getlocationforlist(this.filterInput).subscribe(res => {
       res.sort((a, b) => { //for sort elements
      return a.locationname.localeCompare(b.locationname);
    })
      this.locationList = res;
      if (this.isEdit && this.locationList.length > 0) {
        const loclist = this.utilityservice.stringFromNumArray(this.existingdetails[0].locationid);
        const locid = loclist.map(id => this.locationList.find(item => item.locationid === id)).filter(item => item !== undefined);
        // this.userForm.patchValue({ 'locationid': locid });
        if (locid.length > 0) {
  this.userForm.patchValue({ 'locationid': locid });
} else {
  this.userForm.patchValue({ locationid: [] });
}
        

      }
    })
  }
  public validation_message = {
    role:[{ type: 'required', message: 'Role is required.' }],
      loginid: [
      { type: 'required', message: 'Login id is required.' },
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end.' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special characters are not allowed ( % and ' ).` },
      { type: 'maxlength', message: 'Maximum length exceeded.' },
    ],
    firstname: [
      { type: 'required', message: 'First Name is required.' },
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end.' },
      { type: 'NOTALLOW_SPECIAL_CHAR_NAME', message: `Special characters are not allowed.` },
      { type: 'maxlength', message: 'Maximum length exceeded.' },
    ],
    lastname: [
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR_NAME', message:`Special characters are not allowed.`},
      { type: 'maxlength', message: 'Maximum length exceeded.' },
    ],
    departmentid: [{ type: 'required', message: 'Department is required.' }],
    emailadd: [{ type: 'required', message: 'Email is required.' },
      { type: 'maxlength', message: 'Maximum length exceeded.' }, 
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end.' },
      {type:'EMAIL',message: 'Email format is incorrect.'}
    ],
    managerid: [{ type: '', message: '' }],
    companyid: [{ type: 'required', message: 'Entity is required.' }],
    verticalid: [{ type: 'required', message: 'Vertical is required.' }],
    verticalid1: [{ type: 'required', message: 'User Vertical is required.' }],
    locationid: [{ type: 'required', message: 'Location is required.' }],
    emailalerts: [{ type: 'required', message: '' }],
    mobilenumber: [{ type: 'maxlength', message: 'Maximum length exceeded.' },
     { type:'PHONE_PATTERN' , message:'Mobile Number is invalid.'}
    ],
    emailcc: [{ type: 'required', message: '' }],
    userrole: [{ type: 'required', message: 'User role is required.' }],
    productid: [{ type: 'required', message: 'Product is required.' }],
    groupid:[{ type: 'required', message: 'Client group is required.' }]

  }
  patchValueForms(data) {
    if(data.threemonthlock==='Y'){
      this.threemonthLocklist.push(
         {
      'labelname': 'Locked',
      'value': 'Y'
    }
      )
    }
    this.userForm.patchValue({
      'managerid': data?.mgrid,
      'activeflag': data?.activeflag,
      'firstname': data?.firstname,
      'lastname': data?.lastname,
      'emailadd': data?.email,
      'lockstatus': data?.lockflag,
      'dailyflag': data?.dailyescflag,
      'emailalerts': data?.mailflag,
      "mobilenumber": data?.mobile,
      "emailcc": data?.isadminemailcc,
      "threemonthlock":data?.threemonthlock,
      "isorgadmin":data?.isorgadmin,
      "loggedflag":data?.loggedflag,
      "repodownloadright":data?.repositorydownloadright,
      "supportloginright":data?.allowghostlogin,
      "userType":data?.clientgroupuser,
      "loginid":data?.loginid

    });
  }
  dismiss() {
    this.ref.close();
  }
  initRows() {
    return this.fb.group({
      productid: ['',Validators.required],
      role: ['',Validators.required],
      create: [true],
      download: [true],
      topmenu: [''],
      candelete:[true]

    });
  }
  onRoleChange(index: number,value) {
    if(value==0){
      this.mappedmoduleForm.invalid
    }
  const control = this.formArr.at(index).get('role');

  control?.markAsTouched();
  control?.updateValueAndValidity();

  this.mappedmoduleForm.updateValueAndValidity();
}
  formInitiliaze() {
    this.userForm = this.fb.group({
      firstname: ['', Validators.compose([Validators.required,Validators.maxLength(100),
                    Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
                   Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR_NAME),
                    ])],
      lastname: ['',Validators.compose([ Validators.maxLength(100),
                  Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
                   Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR_NAME),
                   ])],
      emailadd: ['', Validators.compose([Validators.required,Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),Validators.pattern(VALIDATION_PATTERNS.EMAIL),Validators.maxLength(100)])],
      managerid: ['-1'],
      companyid: ['', Validators.compose([Validators.required])],
      verticalid: [''],
      verticalid1: [''],
      departmentid: ['', Validators.compose([Validators.required])],
      locationid: ['', Validators.compose([Validators.required])],
      emailalerts: ['Y'],
      countryCode:['+91'],
      mobilenumber: ['',Validators.compose([Validators.maxLength(15),Validators.pattern(VALIDATION_PATTERNS.PHONE_PATTERN)])],
      emailcc: ['N'],
      userrole: ['', Validators.compose([Validators.required])],
      productid: ['', Validators.compose([Validators.required])],
      activeflag: ['Y'],
      dailyflag: ['N'],
      lockstatus: ['N'],
         loggedflag: ['N'],
      isorgadmin: ['N'],
      issuportadmin: ['N'],
      userType: ['N', Validators.required],
      groupid: [''],
      loginid: ['',Validators.compose([Validators.maxLength(100),
                    Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
                   Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
                    ])
                  ],
      threemonthlock:['N'],
      supportloginright:[''],
      repodownloadright:['']
    })
  }
ngAfterViewInit() {
  this.formArr.valueChanges.subscribe(() => {
    this.formArr.updateValueAndValidity({ emitEvent: false });
  });
}
  // Add New User
  addUser() { 
    
    
    this.formArr.updateValueAndValidity();
 console.log(this.userForm.controls,"controls");
 

  const mobileValue = this.userForm.value.mobilenumber 
  ? this.userForm.value.countryCode + this.userForm.value.mobilenumber 
  : '';
    if (this.userForm.invalid) {
        Swal.fire('Please fill up/Validate all the mandatory/required fields and then Save!', '', 'warning').then(() => {
             this.validateAllFormFields(this.userForm,this.el);


      })
      // this.validateAllFormFields(this.userForm);
    }
    
     else if(this.isEdit && this.formArr.invalid){
       Swal.fire('Please fill up/Validate all the mandatory/required fields and then Save!', '', 'warning').then(() => {
                            this.mappedmoduleForm.markAllAsTouched();
      this.checklistvalidation()



      });

   
    }
    
       else if (this.numberOfUsers <= this.currentNumberOfusers) {
                         Swal.fire({
                          icon: 'warning',
                          title: 'Maximum Allowed Users Used',
                          text: 'Please Contact Complinity Helpdesk'
                        })
                      }
     else {
      if (this.saveTitle == 'Modify') {
        this.modifyUser(this.userForm.value)
      } else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`
        }).then((value) => {
          if (value.isConfirmed) {
            this.userForm.value.departmentid = this.userForm.value.departmentid.map(e => e.departmentid);
            this.userForm.value.companyid = this.userForm.value.companyid.map(e => e.companyid);
            this.userForm.value.locationid = this.userForm.value.locationid.map(e => e.locationid)
            this.userForm.value.productid = this.userForm.value.productid.map(e => e.productid);
            this.userForm.value.verticalid = this.configparams.requirevertlabel == 'Y' ? this.userForm.value.verticalid.map(e => e.verticalid) : [];
            this.userForm.value.verticalid1 = this.loginuserdetails.orgid == 1 ? [this.userForm.value.verticalid1] : [];
            this.userForm.value.managerid = String(this.userForm.value.managerid);
            this.userForm.value.groupid = this.orgType == 'P' ? this.userForm.value.groupid.map(e => e.groupid) : [];

            let data = this.userForm.value;
            data['csrftoken'] = this.CSRFToken;
            data['authType'] = this.authType;
            data['orgType'] = this.orgType;
            data['userRole'] = this.userForm.get('userrole').value;   
             if(this.authType=='AD'){
          data['loginid'] = this.userForm.get('loginid').value
        }else{
         data['loginid'] = this.userForm.get('emailadd').value;
        }
            data['userType'] = this.userForm.get('userType')?.value;
            data['mobile']=mobileValue
            delete data.mobilenumber;
          //   this.usersService.postuser(data).subscribe((data) => {
          //     Swal.fire("Saved!", "", "success").then(result => {
          //       //this.ref.close()
          //     });
          //   }, error => {
          //     Swal.fire({
          //       icon: "error",
          //       title: "Oops...",
          //       text: error.error.error,
          //       footer: "error status is :" + ' ' + error.status
          //     });
          //   });
          // }
          this.spinner.show()
            this.usersService.postuser(data).subscribe({
            next: (response: any) => {
                        this.spinner.hide()
              if (response?.response === 'exists') {
                Swal.fire ("User already exists!", "", "error");
              } else if(response?.response === "success"){
                Swal.fire("User is added successfully!", "", "success").then(() => {
                  this.ref.close('Save');
                });
              }
            },
            error: (error) => {
              this.spinner.hide();

              if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.error?.error || "An unexpected error occurred.",
                footer: `Error status is: ${error.status}`
              });}
            }
                  });
                }
          
          else if (value.isDenied) {
                          this.spinner.hide();
            Swal.fire("Changes are not saved", "", "info").then(()=>{
              this.ref.close()
            })
            
          }
        });
      }
    }
  }

  modifyUser(data: any) {
  
        let depid=[];

    if(data.departmentid.length>0){
      this.userForm.value.departmentid.map(e => {
        if(e!=undefined && e.departmentid!=undefined){
         depid.push(e.departmentid)
        }
        })      
    }
    let companyid=[]
    if(data.companyid.length>0){
      this.userForm.value.companyid.map(e => {
        if(e!=undefined && e.companyid!=undefined){
         companyid.push(e.companyid)
        }
        })      
    }
    let verticalid=[]
    if(data.verticalid.length>0){
      this.userForm.value.verticalid.map(e => {
        if(e!=undefined && e.verticalid!=undefined){
         verticalid.push(e.verticalid)
        }
        })      
    }

     let verticalid1=[]
    // if(data.verticalid1.length>0){
    //   this.userForm.value.verticalid1.map(e => {
    //     if(e!=undefined && e.verticalid!=undefined){
    //      verticalid1.push(e.verticalid)
    //     }
    //     })      
    // }
     verticalid1.push(this.userForm.value.verticalid1);
 
    let locationid=[]
    if(data.locationid.length>0){
      this.userForm.value.locationid.map(e => {
        if(e!=undefined && e.locationid!=undefined){
         locationid.push(e.locationid)
        }
        })      
    }
    //   if(data.managerid.length>0){
    //   this.userForm.value.departmentid.map(e => {
    //     if(e!=undefined && e.departmentid!=undefined){
    //      depid.push(e.departmentid)
    //     }
    //     })      
    // }else{
    //   data.managerid=''
    // }

     
    
    //alert("inside modify fn"); 
    this.rightsList = [];
    this.formArr.controls.forEach((control: FormGroup) => {
      this.rightsList.push({
        create: control.get('create').value == true ? 'Y' : 'N',
        download: control.get('download').value == true ? 'Y' : 'N',
        topmenu: control.get('topmenu').value == true ? 'Y' : 'N',
        productid: control.get('productid').value,
        roleid: control.get('role').value
      });
    });
    const topMenuCount = this.rightsList.filter(item => item.topmenu === 'Y').length;

if (topMenuCount > 6) {
  Swal.fire({
    icon: 'warning',
    text: 'You can only choose a maximum of six product to appear on the top menu'
  });
}
else{
    
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          data["productdetailsList"] = this.rightsList;
          data.departmentid = depid
          data.companyid = companyid;
          data.locationid = locationid;
          data.verticalid = this.configparams.requirevertlabel == 'Y' ? verticalid : [];
          data.verticalid1 = this.loginuserdetails.orgid == 1 ? verticalid1 : [];
          data.managerid = data.managerid ?? -1;         
           delete data.userrole;
          delete data.productid;
          data['threemonthlock'] =this.userForm.get('threemonthlock').value
                    data['repodownloadright'] =this.userForm.get('repodownloadright').value
          data['supportloginright'] =this.userForm.get('supportloginright').value
          data['id'] = this.userid;
          data['isgroupuser'] = 'N';
          data['groupid'] =this.orgType == 'P' ? this.userForm.value.groupid.map(e => e.groupid).toString() : '';
          data['orgipauthenticationflag'] = 'N';
          if(this.authType=='AD'){
          data['loginid'] = this.userForm.get('loginid').value
          }else{
            data['loginid'] =this.userForm.get('emailadd').value
          }
          data['csrftoken'] = this.CSRFToken;
          if(this.loginuserdetails.orgid===0){
        data["orgid"]=this.filterInput.torganisation;
  }
          this.spinner.show();
          this.usersService.modifyUser(data).subscribe((data) => {
            console.log(data);
            this.spinner.hide()
            Swal.fire("User is modified successfully!", "", "success").then(result => {
              this.ref.close('Save')
            });
          }, error => {
            this.spinner.hide()

            if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
            console.log(error.error,"error");
            
            Swal.fire({
              icon: "error",
              title: error.error.response,
            });}
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });}
  }
  onSelectDep(selectedIds) {
    if (selectedIds.length > 0) {
      this.selectedDepartment = [];
      this.selectedDepartment.push(selectedIds.map(e => e.departmentid));
    }
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  onClientGroupChange(value){
    this.entityList=[];
    console.log(value);
    let groupid=''
    if(value.length>0){
     groupid= value.map(e=>e.groupid).toString()
    }
    const payload={groupid:groupid} 
    this.entityList=[];
    this.usersService.getgroupcompany(payload).subscribe((res:any)=>{
      this.entityList=res;
    this.userForm.patchValue({ companyid: '' });


     })
  }

  onLicenseChange(type: string) {
    this.licenseType = type; 
    if (type === 'businessUser') {
      this.userForm.get('userRole')?.setValue(null);
      this.userForm.get('userRole')?.disable();
      this.isBusinessUser = "Y";
      if (this.isBusinessUserRequired == "Y") {
        if (this.currentNumberOfBusinessUsers >= this.numberOfBusinessUsers) {
          Swal.fire({
            icon: 'warning',
            title: 'Maximum allowed active business users as per License are already used',
            text: 'Please Contact Complinity Helpdesk'
          });
        }
      }
    } 
    else if(type == 'normalLicensed') {
      this.userForm.get('userRole')?.enable();
      this.isBusinessUser = "N";
    }
    else if(type == 'firmUser')
    {
      this.userForm.get('userRole')?.enable();
      this.userForm.get('managerid')?.enable();       
    }
    else if(type == 'clientUser')
    {
      this.userForm.get('userRole')?.setValue(null);
      this.userForm.get('userRole')?.disable();

      this.userForm.get('managerid')?.setValue(null);
      this.userForm.get('managerid')?.disable();       
    }
    this.payload = {
      ...this.payload,
      isBusinessUser: this.isBusinessUser
    };
    if(this.orgType != 'P')
    this.getProductList(this.payload); 
  }


  hideProductAndRole() {
    this.userForm.get('userRole')?.setValue(null);
    this.userForm.get('userRole')?.disable();
  }


  showProductAndRole() {
    this.userForm.get('userRole')?.enable();
  }
  onManagerChange(managerId: any) { 
    this.getMappedEntity(managerId); 
    if(this.orgType == "P")
    {
      this.getMappedGroup(managerId);
    }
  }

  getMappedEntity(managerId: any) {
    this.usersService.getMappedCompany(managerId).subscribe(res => {

      this.entityList = res;
      const autoSelectCompanies = this.entityList.filter(item => item.mappedCompanyId !== null);

      if (this.isEdit && this.existingdetails[0]?.companyid) {
        const companyidlist = this.utilityservice.stringFromNumArray(this.existingdetails[0].companyid);
        const selectedCompanies = companyidlist.map(id => this.entityList.find(item => item.companyid === id)).filter(x => x);
        this.userForm.patchValue({ companyid: selectedCompanies });
      }
      else {
        if(autoSelectCompanies!==undefined){
        this.userForm.patchValue({ companyid: autoSelectCompanies });
      }else{
                this.userForm.patchValue({ companyid: '' });

      }
      }
    });
  }

  getClientGroupList() {
    this.clientGroupList = [];
    this.usersService.getDistinctgroup().subscribe(res => {
      this.clientGroupList = res;

      if (this.isEdit && this.clientGroupList.length > 0) {
        const list = this.utilityservice.stringFromNumArray(this.existingdetails[0].groupid);
        console.log(list);
        let id = ''
        list.map(e => {
          if (e !== 0) {
            id = list.map(id => this.clientGroupList.find(item => item.groupid === id));
          }
        })
        this.userForm.patchValue({ 'groupid': id });
      }
    })
  }
    getcompanyTooltip(values:any[]): string {
      if (!Array.isArray(values) || values.length === 0) {
    return 'Select Entity';
  }

  const names = values
    .filter(v => v && v.companyname)   // remove undefined/null items
    .map(v => v.companyname);

  if (names.length === 0) {
    return 'Select Entity';
  }

  return names.length > 3
    ? `${names.slice(0, 3).join(', ')} +${names.length - 3} more`
    : names.join(', ');
}
   getclientgroupTooltip(values:any[]): string {
   if (!values?.length) return 'Client Group';

  const names = values
  .filter(v=>v && v.grupname)
  .map(v => v.grupname);

  return names.length > 3
    ? `${names.slice(0,3).join(', ')}`
    : names.join(', ');
  }
  getverticcalTooltip(values: any[]): string {

  if (!values?.length) {
    return `Select ${this.loginuserdetails?.vertlabelname}`;
  }

  const names = values
    .filter(v => v && v.name)   // ✅ remove null, undefined, empty
    .map(v => v.name);

  return names.join(', ');
}
getvertical1Tooltip(values: any[]): string {

  if (!values?.length) {
    return `Select User Vertical`;
  }

  const names = values
    .filter(v => v && v.name)   // ✅ remove null, undefined, empty
    .map(v => v.name);

  return names.join(', ');
}
  getdepTooltip(values:any[]): string {
   if (!values?.length) {return `Select Department`;}

  const names = values
  .filter(v=>v && v.departmentname)
  .map(v => v.departmentname);

  return names.join(', ');
  }
   getlocTooltip(values:any[]): string {
   if (!values?.length) {return `Select Location`;}

  const names = values
  .filter(v=>v && v.locationname)
  .map(v => v.locationname);

  return names.join(', ');
  }
  getProductTooltip(values:any[]): string {
   if (!values?.length){ return `Select Product`;}

  const names = values
  .filter(v=>v && v.productinitial)
  .map(v => v.productinitial);

  return names.join(', ');
  }

  getMappedGroup(managerId: any) {
    this.usersService.getMappedGroup(managerId).subscribe(res => {

      this.clientGroupList = res;
      const autoSelectGroup = this.clientGroupList.filter(item => item.mappedGroupId !== null);

      if (this.isEdit && this.existingdetails[0]?.groupid) {
        const groupidlist = this.utilityservice.stringFromNumArray(this.existingdetails[0].groupid);
        const selectedGroup = groupidlist.map(id => this.clientGroupList.find(item => item.groupid === id)).filter(x => x);
        this.userForm.patchValue({ groupid: selectedGroup });
      }
      else {
        this.userForm.patchValue({ groupid: autoSelectGroup });
      
      }
    });
  }
  //  getChecklistDetails(index: number): FormArray {
  //   return this.checklistarray.at(index).get('checklistdetails') as FormArray;
  // }
checklistvalidation() {
  document.querySelector('p-dynamicdialog')?.removeAttribute('aria-hidden');

  let firstInvalidHandled = false;
    const details =this.formArr.controls;
    console.log(details,"details");
    
    details.forEach((innerCtrl: any, i: number) => {
  console.log(innerCtrl,"innercontrol");
        innerCtrl.get('productid')?.markAsTouched({ onlySelf: true });
      innerCtrl.get('role')?.markAsTouched({ onlySelf: true });

      //  Check invalid control
      const keys = ['productid', 'role'];

      keys.forEach((fieldName) => {
        const ctrl = innerCtrl.get(fieldName);

        console.log(ctrl,"ctrl");
        console.log(`${fieldName}-${i} filedname`);
        
        
        if (ctrl && ctrl.invalid) {

          if (firstInvalidHandled) return;

          firstInvalidHandled = true;
   
          const fieldId = `${fieldName}-${i}`;
          const element = document.getElementById(fieldId);

          if (!element) return;

          console.warn("Invalid field →", fieldId);

          // 3️⃣ Scroll into view
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });

          setTimeout(() => {          
            if (element.tagName === 'P-DROPDOWN') {
              const dropdownCmp = element as any;
              if (dropdownCmp.show) {
                dropdownCmp.show();   // <-- This is the official method to open dropdown
              } else {
                // fallback: click the hidden trigger button
                const trigger = element.querySelector('.p-dropdown-trigger');
                trigger?.dispatchEvent(new Event('click', { bubbles: true }));
              }
            }
          }, 300);
        }
      });

    });
  // });
}

    countryCodes = [
  { label: '+1 (US)', value: '+1' },
  { label: '+91 (IN)', value: '+91' },
  { label: '+44 (UK)', value: '+44' },
    { label: '+61 (AU)', value: '+61' }

  // Add more as needed
];

}
